/* Flavourite Wine, feedbackpunt 46: bevestiging bij toevoegen aan de winkelwagen.

   Waarom zo: het theme heeft wel een patroon (data-added op de knop, gestuurd door
   add-to-cart-component), maar de flav-knoppen zitten in een product-form-component
   zonder die ref, dus dat patroon grijpt hier niet. In plaats van in de koopflow te
   snijden luistert dit bestand alleen mee: het kijkt naar het aantal in het
   winkelwagenbolletje. Verandert dat, dan is er echt iets toegevoegd en verschijnt
   er kort een melding. Mislukt de toevoeging, dan verandert het aantal niet en
   blijft de melding dus terecht weg.

   flav-toast-knop-p1: de melding is een knop geworden. Een klik opent de
   winkelwagen-lade, precies zoals het icoon in de header. Het is een gewone link
   naar de winkelwagen; alleen als de lade er is, vangen we de klik af en openen
   we die. Zonder lade (winkelwagen als pagina, of de lade nog niet geladen) gaat
   de link dus gewoon naar /cart. Omdat je nu moet kunnen klikken staat hij langer
   in beeld en blijft hij staan zolang de muis of de focus erop staat. In de open
   lade en op de winkelwagenpagina tonen we hem niet: daar zie je het aantal al
   veranderen en zou de knop nergens heen gaan. Een zichtbaar "Bekijken" erachter
   stond vreemd en is weer weg; voor schermlezers staat het er verborgen nog bij,
   zodat duidelijk blijft waar de link heen gaat.

   Volledig additief: het raakt geen bestaande component, knop of formulier aan. */
(function () {
  if (window.flavCartFeedback) return;
  window.flavCartFeedback = true;

  var TOON_MS = 6000;
  var NA_HOVER_MS = 2500;
  var melding = null;
  var knop = null;
  var timer = null;
  var verbergTimer = null;

  function bubbel() {
    return document.querySelector('.header-actions__cart-icon .cart-bubble');
  }

  function lade() {
    return document.getElementById('cart-drawer');
  }

  // Theme staat als const in snippets/scripts.liquid, dus niet op window.
  function winkelwagenUrl() {
    return (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function aantal() {
    var b = bubbel();
    if (!b) return null;
    var t = (b.textContent || '').replace(/[^0-9]/g, '');
    return t === '' ? 0 : parseInt(t, 10);
  }

  // De klant kijkt al naar de winkelwagen: de lade staat open, of we zijn op de
  // winkelwagenpagina (daar rendert het theme geen lade).
  function winkelwagenInBeeld() {
    var d = lade();
    if (d) return d.hasAttribute('open');
    return window.location.pathname.replace(/\/$/, '') === winkelwagenUrl().replace(/\/$/, '');
  }

  function openWinkelwagen(e) {
    var d = lade();
    if (!d || typeof d.open !== 'function') return;
    e.preventDefault();
    // De lade zet bij sluiten de focus terug op wat bij openen gefocust was. Dat
    // moet het winkelwagenicoon zijn en niet deze melding, want die is dan weg.
    var icoon = document.querySelector('[aria-controls="cart-drawer"]');
    if (icoon) icoon.focus({ preventScroll: true });
    d.open();
    verberg();
  }

  function pauzeer() {
    if (timer) clearTimeout(timer);
    timer = null;
  }

  function hervat() {
    if (!melding || !melding.classList.contains('is-zichtbaar')) return;
    pauzeer();
    timer = setTimeout(verberg, NA_HOVER_MS);
  }

  function maakMelding() {
    if (melding) return melding;
    // De wrapper is de live region en regelt plek en overgang; de link erin is de
    // knop. Een role="status" op de link zelf zou de linksemantiek wegdrukken.
    melding = document.createElement('div');
    melding.className = 'flav-cart-toast';
    melding.setAttribute('role', 'status');
    melding.setAttribute('aria-live', 'polite');
    melding.hidden = true;

    knop = document.createElement('a');
    knop.className = 'flav-cart-toast__knop';
    knop.href = winkelwagenUrl();
    if (lade()) knop.setAttribute('aria-controls', 'cart-drawer');
    knop.addEventListener('click', openWinkelwagen);

    melding.appendChild(knop);
    melding.addEventListener('mouseenter', pauzeer);
    melding.addEventListener('mouseleave', hervat);
    melding.addEventListener('focusin', pauzeer);
    melding.addEventListener('focusout', hervat);
    document.body.appendChild(melding);
    return melding;
  }

  function toon(tekst, actie) {
    var el = maakMelding();
    if (verbergTimer) clearTimeout(verbergTimer);
    verbergTimer = null;

    var t = document.createElement('span');
    t.className = 'flav-cart-toast__tekst';
    t.textContent = tekst;
    var a = document.createElement('span');
    a.className = 'visually-hidden';
    a.textContent = actie;
    knop.replaceChildren(t, a);

    el.hidden = false;
    // Forceer een reflow zodat de overgang ook bij snel achter elkaar toevoegen loopt.
    void el.offsetWidth;
    el.classList.add('is-zichtbaar');
    pauzeer();
    timer = setTimeout(verberg, TOON_MS);
  }

  function verberg() {
    pauzeer();
    if (!melding || !melding.classList.contains('is-zichtbaar')) return;
    melding.classList.remove('is-zichtbaar');
    verbergTimer = setTimeout(function () {
      melding.hidden = true;
      verbergTimer = null;
    }, 240);
  }

  function start() {
    var b = bubbel();
    if (!b) return;
    var vorig = aantal();
    var obs = new MutationObserver(function () {
      var nu = aantal();
      if (nu === null || nu === vorig) return;
      var meer = nu > vorig;
      vorig = nu;
      if (meer && !winkelwagenInBeeld()) toon('Toegevoegd aan je winkelwagen', ', bekijk je winkelwagen');
    });
    obs.observe(b, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
